export default function UnfocusFlash(mark: string): void {
  if (!document) {
    return
  }
  if (!document.hasFocus()) {
    const originalTitle = document.title
    let flashState = false
    const flash = setInterval(() => {
      if (document.hasFocus()) {
        clearInterval(flash)
        document.title = originalTitle
      } else {
        document.title = !flashState
          ? `${mark} ${originalTitle}`
          : originalTitle
        flashState = !flashState
      }
    }, 1000)
  }
}
